// @ts-nocheck
import { useMemo } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Box, Drawer, Grid, useMediaQuery } from "@mui/material";

// project import
import DrawerHeader from "./DrawerHeader";
import DrawerContent from "./DrawerContent";
import MiniDrawerStyled from "./MiniDrawerStyled";
import useMenu from "contexts/MenuContext";

import { DRAWER_WIDTH } from "config";
import { nuwaySymbol } from "components/logo/brand";

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

// front-end's MainDrawer without the plan card (partners have no plan).
const PoweredBy = ({ open }: { open: boolean }) => {
  const theme = useTheme();
  return (
    <Grid container justifyContent={"center"} sx={{ alignItems: "end" }}>
      <Grid
        item
        style={
          open
            ? {
                padding: "0px 16px 0px 16px",
                alignItems: "center",
                display: "flex",
                marginBottom: "8px",
              }
            : {
                padding: "10px 8px",
                alignItems: "center",
                display: "flex",
                marginBottom: "8px",
              }
        }
      >
        {open && <span style={{ marginRight: "5px" }}> Powered by </span>}
        <a
          href="https://nuway.co"
          target="_blank"
          rel="noreferrer"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <img
            style={{ width: "20px" }}
            src={nuwaySymbol(theme.palette.mode === "dark")}
            alt=""
          />
        </a>
      </Grid>
    </Grid>
  );
};

const MainDrawer = () => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("lg"));
  const { drawerOpen, openDrawer } = useMenu();

  // header content
  const drawerContent = useMemo(() => <DrawerContent />, []);
  const drawerHeader = useMemo(
    () => <DrawerHeader open={drawerOpen} />,
    [drawerOpen]
  );

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { md: 0 }, zIndex: 1200 }}
      aria-label="main navigation"
    >
      {!matchDownMD ? (
        <MiniDrawerStyled variant="permanent" open={drawerOpen}>
          {drawerHeader}
          {drawerContent}
          <PoweredBy open={drawerOpen} />
        </MiniDrawerStyled>
      ) : (
        <Drawer
          variant="temporary"
          open={drawerOpen}
          onClose={() => openDrawer(!drawerOpen)}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", lg: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: DRAWER_WIDTH,
              borderRight: `1px solid ${theme.palette.divider}`,
              backgroundImage: "none",
              boxShadow: "inherit",
              overflow: "hidden",
            },
          }}
        >
          {drawerHeader}
          {drawerContent}
          <PoweredBy open={drawerOpen} />
        </Drawer>
      )}
    </Box>
  );
};

export default MainDrawer;
